'use strict';

/* global yith_wcaf */

import YITH_WCAF_Ajax from '../../../src/modules/ajax.js';
import YITH_WCAF_Admin_Modal from './yith-wcaf-admin-modal';

export default class YITH_WCAF_Admin_Ajax_Modal extends YITH_WCAF_Admin_Modal {
	// action used to retrieve template
	action;

	// security used to retrieve templates
	security;

	constructor( $opener, args ) {
		super( $opener, args );

		if ( ! this.$opener?.length ) {
			return;
		}

		this.action = this.$opener.data( 'action' );
		this.security = this.$opener.data( 'security' );
	}

	async onOpen() {
		if ( this.action && this.security ) {
			const template = await this.loadTemplate();

			if ( ! template ) {
				return false;
			}

			this.args.content = template;
		}

		super.onOpen();
	}

	loadTemplate() {
		let data = this.args?.data || {};

		if ( 'function' === typeof data ) {
			data = data.call( this );
		}

		let blockTarget = this.args?.blockTarget || this.$opener;

		if ( 'function' === typeof blockTarget ) {
			blockTarget = blockTarget.call( this, data );
		}

		return new Promise( ( resolve ) => {
			YITH_WCAF_Ajax.get
				.call( blockTarget, this.action, this.security, data )
				.done( ( result ) => {
					if ( ! result?.success || ! result?.data?.template ) {
						resolve( false );
					}

					resolve( result.data.template );
				} )
				.fail( () => resolve( false ) );
		} );
	}
}
